import { queryOptions, skipToken } from '@tanstack/react-query'

import { importPractitionerProfiles, importPractitionerProfileSurgeryTypeGroups } from '~/store/di-entity.api.generated'

export const practitionerProfileQueries = {
    importAll: () =>
        queryOptions({
            queryKey: ['practitionerProfiles'],
            queryFn: () => Promise.all([importPractitionerProfiles({}), importPractitionerProfileSurgeryTypeGroups({})]),
        }),
    importByPractitionerId: (practitionerId?: number) =>
        queryOptions({
            queryKey: ['practitionerProfiles', practitionerId],
            queryFn:
                practitionerId !== undefined
                    ? () =>
                          Promise.all([
                              importPractitionerProfiles({ practitioner_id: practitionerId }),
                              importPractitionerProfileSurgeryTypeGroups({
                                  'practitioner_profile.practitioner_id:in': String(practitionerId),
                              }),
                          ])
                    : skipToken,
        }),
}
